import useIntl from '@afosto/utils-react/intl/useIntl';
import { useHistory } from 'react-router-dom';
import { useSnackbar } from 'notistack';
import { apps as appsApi } from '@afosto/apps/api/Apps';
import formatAppConfiguration from '../formatAppConfiguration';
import translations from './translations';

export const useInstallApp = () => {
  const history = useHistory();
  const intl = useIntl();
  const { enqueueSnackbar } = useSnackbar();

  return async (app, { name, configuration, credentials }) => {
    try {
      const response = await appsApi.installApp(app.code, {
        name,
        configuration: formatAppConfiguration(configuration, app.code),
        credentials,
      });

      if (response?.data?.integration) {
        history.push(`/integrations/${response.data.integration.id}`);
      } else if (response?.data?.redirect_url) {
        window.location.href = response.data.redirect_url;
      }
    } catch (err) {
      enqueueSnackbar(intl.formatMessage(translations.feedback.integrationNotCreated), {
        variant: 'error',
      });
    }
  };
};

export default useInstallApp;
